<template>
  <div class="app-container">
    <div style="margin-bottom: 20px">
      <el-form
        ref="formSearch" :model="queryForm" label-position="top"
        size="small"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item prop="timeType">
              <template slot="label">
                <div class="selectLabel">
                  <el-select v-model="queryForm.params.timeType" :style="IsWidth01">
                    <el-option
                      v-for="item in timeTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </div>
              </template>
              <!--网点入库时间-->
              <el-date-picker
                v-model="timeValue"
                :default-time="['00:00:00', '23:59:59']"
                :format="$i18n.locale == 'zh' ? zhDate : ptDate"
                :placeholder="$t('newOrder.SelectDatetime')"
                range-separator="~"
                style="width: 100%"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!--运单状态-->
            <el-form-item :label="$t('newOrder.waybillStatus')" style="width: 100%">
              <el-select
                v-model="queryForm.params.waybillStatus"
                :placeholder="$t('GlobalSetObj.all')"
                clearable
                collapse-tags
                filterable
                multiple
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in waybillStatusList"
                  :key="item.code"
                  :label="item.label"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!--客户名称-->
            <el-form-item :label="$t('collectionCenter.CustomerName')" style="width: 100%">
              <el-select
                v-model="queryForm.params.customerIds"
                :placeholder="$t('spareNumberPoo.Only10AreDisplayed')"
                :remote-method="getCustomerPage"
                clearable
                collapse-tags
                filterable
                multiple
                remote
                reserve-keyword
                style="width: 100%"
                @focus="getCustomerPage()"
              >
                <el-option
                  v-for="item in customerList"
                  :key="item.id"
                  :label="item.customerAlias + '(' + item.username + ')'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!-- 大区： -->
            <el-form-item :label="$t('collectionCenter.region')">
              <el-select
                v-model="queryForm.params.regionId"
                :placeholder="$t('collectionCenter.tudo')"
                clearable
                filterable
                style="width: 100%"
                @change="changeArea"
              >
                <el-option
                  v-for="item in bigAreaList"
                  :key="item.id"
                  :label="item.zhName + '（' + item.puName + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 收件人州 -->
          <el-col :span="4">
            <el-form-item :label="$t('newOrder.RecipientState')">
              <el-select
                v-model="queryForm.params.receiveStates"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in StateList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.label"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="4">
            <!-- 是否超时 -->
            <el-form-item :label="$t('orderCenterCont.TimeoutOrNot')">
              <el-select
                v-model="queryForm.params.isTimeout"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                style="width: 100%"
              >
                <el-option :key="1" :label="$t('GlobalSetObj.yes')" :value="1" /><!--是-->
                <el-option :key="0" :label="$t('GlobalSetObj.No')" :value="0" /><!--否-->
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!-- 时效起点HUB -->
            <el-form-item :label="$t('collectionCenter.effectiveStartHub')">
              <el-select
                v-model="queryForm.params.transitCenterIds"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in departmentList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!--  运单号   -->
            <el-form-item prop="waybillNumberType">
              <template slot="label">
                <div class="selectLabel">
                  <el-select v-model="queryForm.params.waybillNumberType" :style="IsWidth">
                    <el-option key="1" :label="$t('newOrder.waybillNumber')" :value="0" />
                    <el-option key="2" :label="$t('GlobalSetObj.ScanNumber')" :value="1" />
                  </el-select>
                </div>
              </template>
              <el-input
                v-model="queryForm.params.inputValue"
                :placeholder="$t('newOrder.PreciseSearch1')"
                :rows="1"
                style="width: 100%"
                type="textarea"
              />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <div style="margin-top: 27px">
              <el-button
                icon="el-icon-search"
                size="small"
                type="primary"
                @click="searchResources(1)"
              >{{ $t('operationCenter.Procurar') }}
              </el-button>
              <el-button icon="el-icon-refresh-left" size="small" @click="searchResources(2)">
                {{ $t('operationCenter.reset') }}
              </el-button>
              <el-button
                icon="el-icon-upload2"
                size="small"
                style="margin-bottom: 10px"
                type="primary"
                @click="allExportOrder"
              >{{ $t('newOrder.export') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-table
      :data="tableData"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
      border
    >
      <el-table-column
        :label="$t('GlobalSetObj.serial')" align="center" type="index"
        width="80"
      />
      <el-table-column
        v-for="(item, ind) in tableHeaderList"
        :key="ind"
        :align="item.align"
        :min-width="item.width"
        :prop="item.prop"
        :show-overflow-tooltip="true"
      >
        <template slot="header">
          <div>{{ item.label }}</div>
        </template>
        <template slot-scope="scope">
          <div
            v-if="item.prop === 'waybillNumber'"
            style="color: #409EFF; cursor: pointer"
            @click="toOrderDetail(scope.row)"
          >
            {{ scope.row.waybillNumber }}
          </div>
          <div v-else>
            {{ scope.row[item.prop] || '--' }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        :current-page.sync="queryForm.pageNumber"
        :page-size.sync="queryForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 10px 0"
        @current-change="getCurrentTableData"
        @size-change="getSizeTableData"
      />
    </div>

    <!--详情-->
    <el-drawer
      :append-to-body="true"
      :visible.sync="waybillDescription"
      custom-class="drawerClass"
      direction="ltr"
      size="90%"
    >
      <div style="height: calc(100vh - 67px); overflow: auto">
        <detailPage :key="detailKey" :query-track-param="queryTrackParam" query-type="1" />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  getLgAreaListData,
  orderWaybillInternalAgingExport,
  orderWaybillInternalAgingPage,
  regionQueryList,
  getSiteTransfer
} from '@/api/orderApi';
import dayjs from 'dayjs';
import { waybillStatusList } from '@/utils/enumData';
import { apiCustomerPage } from '@/api/customer';
import { goResourceTaskList } from '@/utils/goExportList';
import detailPage from '@/components/detailComponent/detailPage.vue';
import {
  searchSiteIdList
} from '@/api/lanshou';

export default {
  name: 'InternalTimeLimit',
  components: {
    detailPage
  },
  data() {
    return {
      // 详情
      waybillDescription: false,
      detailKey: new Date().getTime(),
      queryTrackParam: {},
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          waybillNumberType: 0,
          timeType: 0,
          receiveStates: [],
          siteIdList: [],
          waybillStatus: [],
          customerIds: [],
          inputValue: '',
          regionId: '',
          isTimeout: '',
          isTest: 1, // 数据类型（1正式 2测试）
          transitCenterIds: []
        }
      },
      departmentList: [],
      bigAreaList: [],
      waybillStatusList: waybillStatusList,
      tableData: [],
      total: 0,
      StateList: [], // 州
      tableHeaderList: [
        // 运单号
        { label: this.$t('newOrder.waybillNumber'), prop: 'waybillNumber', width: 170 },
        // 扫描单号
        {
          label: this.$t('GlobalSetObj.ScanNumber'),
          prop: 'scanOrderNumber',
          width: 120
        },
        // 状态
        { label: this.$t('newOrder.waybillStatus'), prop: 'waybillStatusName', width: 170 },
        // 最新轨迹时间
        {
          label: this.$t('orderCenterCont.TheLatestTraceTime'),
          prop: 'latestTrackTime',
          width: 160
        },
        // 最新轨迹内容
        {
          label: this.$t('orderCenterCont.zuixinguijineir'),
          prop: 'latestTrackContent',
          width: 160
        },
        // 考核环节
        {
          label: this.$t('uploadFile.assessmentStage'),
          prop: 'assessmentLinkName',
          width: 160
        },
        // 客户名称
        {
          label: this.$t('newOrder.CustomerName'),
          prop: 'customerName',
          width: 160
        },
        // 大区
        {
          label: this.$t('collectionCenter.region'),
          prop: 'regionName',
          width: 160
        },
        // 收件人州
        {
          label: this.$t('newOrder.RecipientState'),
          prop: 'receiveState',
          width: 160
        },
        // 区域
        {
          label: this.$t('placeOrder.area'),
          prop: 'areaName',
          width: 160
        },
        // 时效起点
        {
          label: this.$t('customerManagements.timeframeStartingPointName'),
          prop: 'agingStartTimeName',
          width: 160,
          typeNum: 3
        },
        // 时效起点HUB
        {
          label: this.$t('collectionCenter.effectiveStartHub'),
          prop: 'transitCenterName',
          width: 160
        },
        // 时效起点时间
        {
          label: this.$t('uploadFile.timingStartTime'),
          prop: 'agingStartTime',
          width: 160
        },
        // 时效小时
        {
          label: this.$t('uploadFile.leadTimeHours'),
          prop: 'duration',
          width: 160
        },
        // 要求送达时间
        {
          label: this.$t('uploadFile.requiredDeliveryTime'),
          prop: 'requiredDeliveryTime',
          width: 160
        },
        // 签收时间
        {
          label: this.$t('trajectory.Signingtime'),
          prop: 'actualDeliveryTime',
          width: 160
        },
        // 是否超时
        {
          label: this.$t('orderCenterCont.TimeoutOrNot'),
          prop: 'timeoutName',
          width: 160
        },
        // 超时时长
        {
          label: this.$t('orderCenterCont.TimeoutDuration'),
          prop: 'timeoutDuration',
          width: 160
        }
      ],
      timeTypeList: [
        { label: this.$t('uploadFile.requiredDeliveryTime'), value: 0 },
        { label: this.$t('trajectory.Signingtime'), value: 1 },
        { label: this.$t('uploadFile.timingStartTime'), value: 2 },
        { label: this.$t('newOrder.LatestTime'), value: 3 }
      ],
      timeValue: [],
      customerList: [],
      customerMerchantList: [],
      sitePreData: [],
      // 是否格式化成巴西时间
      isTormat: false,
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      preDeliverStationIds: null
    };
  },
  computed: {
    IsWidth() {
      return {
        width: this.isTormat ? '190px' : '120px'
      };
    },
    IsWidth01() {
      return {
        width: this.isTormat ? '280px' : '210px'
      };
    }
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.getTimer();
    // 获取加盟商选项
    this.getAddress();
    this.getSearchData(1);
    this.getLgAreaData();
    this.getDepartment();
  },
  methods: {
    getDepartment() {
      // 转运中心
      // getSiteTransfer()
      //   .then((res) => {
      //     if (res.code === 200) {
      //       this.departmentList = res.data;
      //     }
      //   })
      //   .catch({});
      searchSiteIdList().then(res => {
        if (res.code === 200) {
          this.departmentList = res.data.map(item => {
            return { id: item.id, name: item.name };
          });
        }
      });
    },
    // 进入运单详情
    toOrderDetail(row) {
      this.queryTrackParam = row;
      this.waybillDescription = true;
      this.detailKey = new Date().getTime();
      setTimeout(() => {
        this.bus.$emit('todetailBox', row.waybillId);
      }, 100);
    },
    // 获取大区列表
    getLgAreaData() {
      regionQueryList('').then((res) => {
        if (res.code === 200) {
          this.bigAreaList = res.data;
        }
      });
    },
    // 搜索
    searchResources(type) {
      if (type === 1) {
        this.queryForm.pageNumber = 1;
        this.getSearchData();
      } else {
        this.preDeliverStationIds = null;
        // 、重置
        this.queryForm = {
          pageSize: 10,
          pageNumber: 1,
          params: {
            waybillNumberType: 0,
            timeType: 0,
            receiveStates: [],
            siteIdList: [],
            waybillStatus: [],
            customerIds: [],
            inputValue: '',
            regionId: '',
            isTimeout: '',
            isTest: 1, // 数据类型（1正式 2测试）
            transitCenterIds: []
          }
        };
        this.getTimer();
        this.getSearchData();
      }
    },
    // 获取最近一星期时间
    getTimer() {
      const day = new Date();
      const brazilTime = day.toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' });
      const today = dayjs(brazilTime).format('YYYY-MM-DD');
      this.timeValue = [today + ' 00:00:00', today + ' 23:59:59'];
    },
    // 获取加盟商时效统计列表
    getSearchData(val) {
      let loading = null;
      if (val === 1) {
        loading = this.$loading({
          fullscreen: true,
          lock: true,
          spinner: 'el-icon-loading',
          text: 'loading...',
          background: 'rgba(250, 250, 250, 0.6)'
        });
      }
      const data = {
        pageNumber: this.queryForm.pageNumber,
        pageSize: this.queryForm.pageSize,
        params: {
          waybillNumbers: [],
          regionId: '',
          isTimeout: this.queryForm.params.isTimeout,
          transitCenterIds: this.queryForm.params.transitCenterIds,
          waybillNumberType: this.queryForm.params.waybillNumberType,
          waybillStatus: this.queryForm.params.waybillStatus,
          customerIds: this.queryForm.params.customerIds,
          timeType: this.queryForm.params.timeType,
          beginTime: '',
          endTime: '',
          customerType: this.queryForm.params.isTest,
          receiveStates: this.queryForm.params.receiveStates,
          preDeliverStationIds: this.preDeliverStationIds
        }
      };
      if (this.timeValue && this.timeValue.length > 0) {
        data.params.beginTime = this.timeValue[0];
        data.params.endTime = this.timeValue[1];
      } else {
        if (!this.queryForm.params.inputValue) {
          this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
          return;
        }
      }
      let inputValList = [];
      if (this.queryForm.params.inputValue) {
        inputValList = this.queryForm.params.inputValue
          .split('\n')
          .filter((item) => item.trim() !== '');
        inputValList = inputValList.map((item) => item.trim());
      }
      data.params.waybillNumbers = inputValList;
      orderWaybillInternalAgingPage(data)
        .then((res) => {
          if (res.code === 200) {
            this.total = res.data.total;
            this.tableData = res.data.records;
            this.tableData.forEach((item) => {
              item.date = item.date || '--';
            });
            if (val === 1) {
              loading.close();
            }
          }
        })
        .catch(() => {
          if (val === 1) {
            loading.close();
          }
        });
    },
    allExportOrder() {
      const data = {
        waybillNumbers: [],
        waybillNumberType: this.queryForm.params.waybillNumberType,
        waybillStatus: this.queryForm.params.waybillStatus,
        customerIds: this.queryForm.params.customerIds,
        timeType: this.queryForm.params.timeType,
        beginTime: '',
        endTime: '',
        customerType: this.queryForm.params.isTest,
        receiveStates: this.queryForm.params.receiveStates,
        preDeliverStationIds: this.preDeliverStationIds,
        transitCenterIds: this.queryForm.params.transitCenterIds
      };
      if (this.timeValue && this.timeValue.length > 0) {
        data.beginTime = this.timeValue[0];
        data.endTime = this.timeValue[1];
      } else {
        if (!this.queryForm.params.inputValue) {
          this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
          return;
        }
      }
      let inputValList = [];
      if (this.queryForm.params.inputValue) {
        inputValList = this.queryForm.params.inputValue.split('\n');
      }
      data.waybillNumbers = inputValList;
      orderWaybillInternalAgingExport(data).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    // 页码变化翻页
    getCurrentTableData(val) {
      this.queryForm.pageNumber = val;
      this.getSearchData();
    },
    // 每页显示数量变化
    getSizeTableData(val) {
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = val;
      this.getSearchData();
    },
    // 州
    getAddress() {
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.StateList = res.data.map((item) => {
            return {
              id: item.id,
              label: `${item.nameEn}`
            };
          });
        }
      });
    },
    // 获取网点列表
    changeArea(val) {
      console.log(val, 'changeArea');
      if (val) {
        this.preDeliverStationIds = [];
        const obj = this.bigAreaList.find((item) => item.id === val);
        console.log(obj, 'objobjobjobj');
        if (obj.sites.length > 0) {
          obj.sites.forEach((item) => {
            this.preDeliverStationIds.push(item.id);
          });
        }
      } else {
        this.preDeliverStationIds = null;
      }
    },
    /**
     * @description 分页获取客户列表
     * @param { string } name 客户名称
     */
    getCustomerPage(name = '') {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      apiCustomerPage(param).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    }
  }
};
</script>

<style scoped>
.app-container >>> .drawerClass header {
  border-bottom: 1px solid #ccc !important;
  margin-bottom: 0 !important;
  padding: 20px 20px 20px !important;
}

.app-container >>> .selectLabel .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  border: none;
  font-weight: bold;
  text-align: left;
  padding: 0;
}
</style>
